import { RootState } from '..';

export const favouriteSpecialistsListSelector = (state: RootState) => state.favouriteSpecialists.data;

export const favouriteSpecialistsLoadingSelector = (state: RootState) => {
  return state.favouriteSpecialists.loading;
};
